import { createTheme } from '@mui/material/styles'
import { theme as baseTheme } from '@chilecompra/react-kit/styles'

const theme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    custom: {
      athensGray: '#E6EAEE',
      baliHai: '#8798AD',
      blueRibbon15: '#2E5BFF26',
      charcoal: '#4A4A4A',
      darkBlue: '#002A46',
      dimGray: '#707070',
      dividerGray: '#D1D8E0',
      dustyGray: '#979797',
      heather: '#BFC5D226',
      ghostBlack: '#00000029',
      ghostWhite: '#FFFFFF0F',
      iconGray: '#768AA2',
      mineShaft: '#3A3A3A'
    }
  }
})

export default theme
